import { Component } from '@angular/core';

@Component({
  selector: 'app-leagues-page',
  templateUrl: './leagues-page.component.html',
  styleUrls: ['./leagues-page.component.scss']
})
export class LeaguesPageComponent {}
